// import { AccountantSetup } from "components/Accountant";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { AccountantSetup } from "../../../components/Accountant";

export const AccountantSetupPage = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Accountant Setup"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[
				// { text: "Accountants", navigateTo: "/accountants/list" },
				// { text: "Add Accountant", navigateTo: "/accountants/setup" },
			]}
			mainContents={<AccountantSetup />}
		/>
	);
};
